import React from 'react'
import PropTypes from 'prop-types'

import PriceSummary from './PriceSummary'
import { MobilePriceSummary, DesktopPriceSummary } from './styles'

const PriceSummaryContainer = ({
  cart,
  isAuthenticated,
  featureFlags,
  TopActions,
  BottomActions
}) => (
  <>
    <MobilePriceSummary>
      <PriceSummary
        dataTestId="mobile"
        TopActions={TopActions}
        BottomActions={BottomActions}
        cart={cart}
        isAuthenticated={isAuthenticated}
        featureFlags={featureFlags}
      />
    </MobilePriceSummary>
    <DesktopPriceSummary>
      <PriceSummary
        dataTestId="desktop"
        TopActions={TopActions}
        BottomActions={BottomActions}
        cart={cart}
        isAuthenticated={isAuthenticated}
        featureFlags={featureFlags}
      />
    </DesktopPriceSummary>
  </>
)

PriceSummaryContainer.propTypes = {
  cart: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  featureFlags: PropTypes.object,
  TopActions: PropTypes.node,
  BottomActions: PropTypes.node
}

PriceSummaryContainer.defaultProps = {
  featureFlags: {},
  TopActions: undefined,
  BottomActions: undefined
}

export default PriceSummaryContainer
